import {api} from "../../api";
import {PortalSelect, PortalSelectOption} from "../PortalSelect";
import React, {useContext, useEffect, useState} from "react";
import {ModelContext} from "../metadata/ModelSource";
import {propsToCSS} from "../css";
import {FormContext} from "../metadata/MDForm";

export function CollectorMake ({attr, ...props}) {
  const applicationModel = useContext(ModelContext);
  const formContext = useContext(FormContext);
  const [state, setState] = useState({
    manufacturers: [],
    loading: false,
  });

  const productVersionIdRef = applicationModel.data.basicPolicy.productVersionIdRef;

  props = {
    value: formContext.getValueByAttr(attr),
    onChange: value => {
      formContext.setValueByAttr(attr, value);
    },
    ...propsToCSS(props),
    ...props
  };

  useEffect(() => {
    if (state.manufacturers.length == 0 && state.loading == false) {
      setState({
        ...state,
        loading: true,
      });
      getYearMake(productVersionIdRef).then((v) => {
        setState({
          ...state,
          manufacturers: v.data.manufacturers,
        });
      });
    }
  });

  return <PortalSelect {...props}>
    {
      state.manufacturers.map((make) => <PortalSelectOption value={make}>
        {make}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const getYearMake = async (year) => {
  return await api.get(`/vehicleManufacturers?year=${year}`).then((v) => {
    return v;
  });
};



